import { categories } from "@/mocks/homeContent";

export default function CategorySection() {
  return (
    <section id="category" className="scroll-mt-16 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-8">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <p className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
              <i className="ri-apps-2-line text-primary-500" aria-hidden="true" />
              从哪说起都行
            </p>
            <h2 className="mt-3 font-heading text-3xl font-semibold text-foreground-950 md:text-4xl">
              逛逛这些栏目
            </h2>
            <p className="mt-2 text-sm text-foreground-600 md:text-base">
              宿舍、干饭、期末、奇遇……总有一个栏目录得下你的故事。
            </p>
          </div>
          <p className="inline-flex items-center gap-1.5 text-sm text-foreground-500">
            <i className="ri-arrow-right-up-line text-primary-500" aria-hidden="true" />
            点栏目可直达对应热帖
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((c) => (
            <a
              key={c.key}
              href="#hot"
              className="group relative overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-shadow hover:shadow-card"
            >
              <div className="relative h-44 w-full overflow-hidden md:h-48">
                <img
                  src={c.image}
                  alt={`${c.label} 主题插画：${c.desc}`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-background-50/90 px-3 py-1 text-xs font-medium text-foreground-800 backdrop-blur-sm">
                  {c.emoji} {c.label}
                </span>
                <span className="absolute right-3 top-3 rounded-full bg-primary-500 px-2.5 py-1 text-xs font-medium text-background-50">
                  {c.count}
                </span>
              </div>
              <div className="flex items-center justify-between gap-3 p-4">
                <p className="text-sm leading-relaxed text-foreground-700">{c.desc}</p>
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-base text-foreground-800 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className="ri-arrow-right-line" aria-hidden="true" />
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}